module.exports = {
      id: "home_banner_display_en-usage",
      viewBox: "0 0 648 445",
      url: __webpack_public_path__ + "images/js_src_vue/page_listary_landing/sprite.d9b7df9a.svg#home_banner_display_en-usage",
      toString: function () {
        return this.url;
      }
    }